export type PhotoAlbumMultiPhotoUploadPayload = {
  maxFiles: number;
};

export const isValidPhotoAlbumMultiPhotoUploadPayload = (payload: unknown): payload is PhotoAlbumMultiPhotoUploadPayload => {
  if (!payload) {
    return false;
  }

  if (typeof payload !== 'object') {
    return false;
  }

  if (!Object.hasOwn(payload, 'maxFiles')) {
    return false;
  }
  return true;
};
